"use client";

import React, { useEffect, useState } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import TaskList from "./taskList/taskList";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { Sidebar } from "react-pro-sidebar";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import "./page.css";
import {
  dailyTasksAppointments,
  Timeslot,
  DailyTask,
  occupiedTimes,
} from "./util/tasks";
import ApiCalendar from "react-google-calendar-api";

const config = {
  clientId:
    "668302632552-0506hu1761l4o7ihigrg9b6oipc7sbn8.apps.googleusercontent.com",
  apiKey: "AIzaSyCYXf3L51eGv3OZtjw6Hb8tNjAJ1clKCDE",
  scope: "https://www.googleapis.com/auth/calendar.readonly",
  discoveryDocs: [
    "https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest",
  ],
};

const apiCalendar = new ApiCalendar(config);

export default function Home() {
  const [collapsed, setCollapsed] = useState(false);
  const [signedIn, setSignedIn] = useState(false);
  const [calendars, setCalendars] = useState([] as any[]);
  const [checkedCalendars, setCheckedCalendars] = useState([] as any[]);
  const [events, setEvents] = useState([] as any[]);
  const [a, setA] = useState(false);
  // const [occupiedTimes, setOccupiedTimes] = useState<Array<Timeslot>>([]);
  // const [dailyTasksAppointments, setDailyTasksAppt] = useState<Array<Timeslot>>([]);

  const now = new Date();

  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const toggleA = () => {
    setA(!a);
  }

  const getCalendarEvents = () => {
    const events = [] as any[];
    while (occupiedTimes.length > 0) {
      occupiedTimes.pop();
    }
    console.log(checkedCalendars);
    for (const calendar of checkedCalendars) {
      apiCalendar
        .listEvents({
          calendarId: calendar.id,
          timeMin: new Date().toISOString(),
          showDeleted: false,
          singleEvents: true,
          maxResults: 10,
          orderBy: "startTime",
        })
        .then((res: any) => {
          console.log("AAAA");
          events.push(
            ...res.result.items.map((event: any) => {
              return {
                start: new Date(event.start.dateTime),
                end: new Date(event.end.dateTime),
                title: event.summary,
              };
            })
          );
          occupiedTimes.push(
            ...res.result.items.map((event: any) => {
              return {
                start: new Date(event.start.dateTime),
                end: new Date(event.end.dateTime),
              };
            })
          );
        });
    }

    setEvents(events);
  };

  useEffect(() => {
    if (signedIn) {
      apiCalendar.listCalendars().then((res: any) => {
        setCalendars(res.result.items);
      });
    }
  }, [signedIn]);

  return (
    <>
      {/** add a popup that hides everything that contains a google sign in button */}
      <main className="flex flex-row">
        <div id="invisible" style={{ visibility: "hidden", width: a ? 1 : 2}}></div>
        <div className="flex flex-row w-auto" id="sidebar">
          <Sidebar
            className="flex flex-col p-4 box-border bg-slate-50"
            backgroundColor="none"
            collapsed={collapsed}
            collapsedWidth="0"
          >
            <div
              className={(signedIn ? "hidden" : "") + " fixed w-full h-full"}
            >
              <div id="login-prompt">
                <h1 className="text-5xl font-light text-center">
                  Task Kitchen
                </h1>
                {signedIn ? (
                  <button
                    onClick={() => apiCalendar.handleSignoutClick()}
                    className="interactive"
                  >
                    Logout
                  </button>
                ) : (
                  <button
                    className="interactive"
                    onClick={function () {
                      apiCalendar.handleAuthClick().then(() => {
                        setSignedIn(true);
                      });
                    }}
                  >
                    Sign In with Google
                  </button>
                )}
              </div>
            </div>
            <div>
              <h2 className="mb-2">Google Calendar</h2>
                <button
                  className="interactive"
                  onClick={() => {
                    getCalendarEvents();
                    toggleA();
                  }}
                >
                  Get Events
                </button>
                <FormGroup>
                  {calendars.map((calendar) => {
                    return (
                      <FormControlLabel
                        key={calendar.id}
                        control={<Checkbox />}
                        onChange={(e: any) => {
                          if (e.target.checked) {
                            setCheckedCalendars((prev) => [
                              ...prev,
                              calendar,
                            ]);
                          } else {
                            setCheckedCalendars((prev) =>
                              prev.filter((c) => c.id !== calendar.id)
                            );
                          }
                        }}
                        defaultChecked={false}
                        label={calendar.summary}
                      />
                    );
                  })}
                </FormGroup>
            </div>
          </Sidebar>
          <button
            onClick={handleToggleSidebar}
            className="flex text-center items-center justify-center"
            id="toggle-sidebar-button"
          >
            {collapsed ? <KeyboardArrowRightIcon /> : <KeyboardArrowLeftIcon />}
          </button>
        </div>
        <TaskList />
        <div id="calendar">
          <Calendar
            localizer={momentLocalizer(moment)}
            events={[...dailyTasksAppointments, ...events]}
            defaultDate={moment().toString()}
            enableAutoScroll={true}
            defaultView="day"
            toolbar={false}
            className="min-w-96 h-full"
            min={new Date(now.setHours(7, 0, 0))}
            max={new Date(now.setHours(23, 0, 0))}
            formats={{
              dayHeaderFormat: (date) => moment(date).format("dddd @ DD"),
            }}
          />
        </div>
      </main>
    </>
  );
}
